// extracted by mini-css-extract-plugin
module.exports = {"link":"NavbarLink_link__U7E6Y","active":"NavbarLink_active__2fz2U"};